import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { SchemasPage } from "./-schemas/schemas.page";

export const Route = createFileRoute("/content/schemas/")({
  validateSearch: validateGridSearch,
  component: SchemasPage,
});
